<template>
  <a-modal
    title="受试者规则配置"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-tabs v-model="key" >
      <a-tab-pane key="patient-again-in" tab="患者再次入组规则">
        <patient-again-in ref="patient-again-in" :projectId="projectId" :fieldList="fieldList"></patient-again-in>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import PatientAgainIn from './patientCheckConfig/PatientAgainIn'
  export default {
    name: 'PatientCheckConfig',
    components: { PatientAgainIn },
    data(){
      return {
        confirmLoading:false,
        rules:{},
        visible:false,
        projectId:'',
        key:'patient-again-in' ,
        fieldList:[],
      }
    },
    methods:{
      view(projectId){
        this.projectId = projectId
        getAction('/project/projectPatientField/editList',{projectId}).then(res=>{
          if(res.success){
            this.fieldList =res.result
          }
        })

        this.visible = true
        this.$nextTick(()=>{
          this.$refs[this.key].loadData()
        })
      },
      handleOk(){
        this.$emit('ok')
        const data = this.$refs[this.key].getData()
        if(data){
          httpAction('/project/patientCheck/edit', data, 'put').then((res) => {
            if (res.success) {
              this.$message.success('保存成功!')
              this.handleCancel()
            } else {
              this.$message.error(res.message)
            }
          })
        }else{
          this.handleCancel()
        }
      },
      handleCancel(){
        this.visible = false
      }
    }
  }
</script>

<style scoped>

</style>